<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useUserStore } from '../../store/useUserStore'
import { isSyncing } from '../../synchronizations/sync'
import { useTimers } from '../../store/timers'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { getAllParentTimers } = storeToRefs(useTimers())

/**
 * This component displays a welcome message.
 * If no timers are logged, it will welcome the rep (by name)
 * If no data are initialized - it will let the rep know.
 */
// eslint-disable-next-line
const props = withDefaults(
  defineProps<{
    showId?: boolean
  }>(),
  {
    showId: false,
  }
)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`timeline.${key}`)

const route = useRoute()
//show message if no timers are logged
const showMessage = computed(() => {
  return getAllParentTimers.value.length < 1 || route.name == 'userInfo'
})
const { first_name, last_name, id: userID } = storeToRefs(useUserStore())
//Welcome message. If no user data, let know app is syncing.
const welcomeMessage = computed(() => {
  if (userID.value.length) {
    return `${label('welcome')}
    ${first_name.value} ${last_name.value}`
  } else {
    //not logged in
    if (!isSyncing.value) {
      return label('pleaseSync')
    } else {
      return label('initializing')
    }
  }
})
</script>
<template>
  <div class="col-4 offset-4" v-if="showMessage">
    <h1 class="text-h6 text-center">
      {{ welcomeMessage }}
    </h1>
    <h1 class="text-h6 text-center" v-if="showId && userID.length">ID: {{ userID }}</h1>
  </div>
</template>
